export default "__VITE_ASSET__xaJPgGPK__"